import * as yup from 'yup';

export const yupSalesOrderItemEditModalSchema = yup.object().shape({
  price: yup.string().required(),
  quantity: yup.number().required(),
});
